import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  prisonerListPanel: {
    display: "flex",
    gap: 16,
    flexDirection: "column",
    alignItems: "flex-start",
    boxSizing: "border-box",
    backgroundColor: "rgba(28, 30, 31)",
    minHeight: 900,
    width: "100%",
    borderRadius: 24,
    border: "1px solid #000000",
    padding: "24px 48px",
    overflowX: "auto",

    [theme.breakpoints.down("lg")]: {
      padding: "16px 32px",
    },
  },

  prisonerListHeader: {
    display: "grid",
    gridTemplateColumns: "3fr 1fr 1fr 1fr 1fr 1fr 1fr",
    gap: 16,
    padding: "16px 0",
    width: "100%",
    boxSizing: "border-box",
    minWidth: "900px",

    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
      color: "#FFFFFF40",
    },
  },

  carListItem: {
    display: "grid",
    gridTemplateColumns: "3fr 1fr 1fr 1fr 1fr 1fr 1fr",
    gap: 16,
    alignItems: "center",
    padding: "8px 0",
    width: "100%",
    boxSizing: "border-box",
    borderBottom: "1px solid #FFFFFF10",
    minWidth: "900px",

    "& a": {
      textDecoration: "none",
      color: theme.palette.text.linkColor,
      fontFamily: "Philosopher",
      fontWeight: 900,
    },

    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
      color: "#FFFFFF",
    },
  },

  repairButton: {
    minWidth: 60,
    borderRadius: 16,
    background: "rgb(255, 255, 255, 0.1)",
    textDecoration: "none",
    fontFamily: "Philosopher",
    fontWeight: 900,
    padding: "4px 16px",
    width: "min-content",

    "&:disabled": {
      opacity: 0.5,
      backgroundColor: "rgb(23, 24, 25)",
      cursor: "not-allowed",
    },

    "& img": {
      width: 20,
      height: 20,
    },
  },

  sellButton: {
    minWidth: 60,
    borderRadius: 16,
    background: "rgb(169, 49, 43)",
    textDecoration: "none",
    fontFamily: "Philosopher",
    fontWeight: 900,
    padding: "4px 32px",
    width: "min-content",
  },
  carItem: {
    display: "flex",
    gap: 8,
    alignItems: "center",

    "& img": {
      width: 48,
      height: 48,
      borderRadius: 4,
      cursor: "pointer",
    },
  },
  carValue: {
    display: "flex",
    gap: 8,
    alignItems: "center",
  },

  citySelect: {
    background: "rgba(255, 255, 255, 0.1)",
    color: theme.palette.text.primary,
    fontFamily: "Philosopher",
    fontWeight: 900,
    textTransform: "none",
    borderRadius: "16px",
    padding: "4px 8px",
    transition: "background 0.3s, color 0.3s",
    height: "min-content",
    width: 130,

    "&:hover": {
      background: theme.palette.background.modalBg,
      opacity: 0.8,
      transition: "300ms",
    },

    [theme.breakpoints.down("lg")]: {
      width: 80,
      boxSizing: "border-box",
      gap: 4,
      padding: "6px 16px",
      fontSize: 12,
    },
  },

  galleryCarName: {
    fontFamily: "Philosopher",
    fontWeight: 900,
    color: "#FFFFFF",
    marginTop: 8,
    textAlign: "center",
  },
}));

export default styles;
